var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteTicket()}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }